var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnMainhomeMypage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 27.5C9.625 27.5 8 27.5 8 25.875C8 24.25 9.625 19.375 17.75 19.375C25.875 19.375 27.5 24.25 27.5 25.875C27.5 27.5 25.875 27.5 25.875 27.5H9.625ZM17.75 17.75C19.0429 17.75 20.2829 17.2364 21.1971 16.3221C22.1114 15.4079 22.625 14.1679 22.625 12.875C22.625 11.5821 22.1114 10.3421 21.1971 9.42785C20.2829 8.51361 19.0429 8 17.75 8C16.4571 8 15.2171 8.51361 14.3029 9.42785C13.3886 10.3421 12.875 11.5821 12.875 12.875C12.875 14.1679 13.3886 15.4079 14.3029 16.3221C15.2171 17.2364 16.4571 17.75 17.75 17.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMainhomeMypage);
export default __webpack_public_path__ + "static/media/icn_mainhome_mypage.728274bcda2181be918cdda6e1d1b56f.svg";
export { ForwardRef as ReactComponent };